import RichText from "@/components/RichText";
import MutedVideo from "../components/MutedVideo";
import { BTN_INVERSE, CONTAINER, DARK_BG, telHref } from "../tokens";

const ROW = "flex gap-3.5 items-baseline";
const KEY = "text-[10px] tracking-[0.2em] uppercase text-gold min-w-[64px]";

// Bande sombre contact (grille 2 colonnes) : « Vous êtes une marque ou un
// professionnel ? », paragraphe, liste Tél. / Mobile / Adresse, bouton
// inversé « Appeler l'atelier » ; à droite, la vidéo de l'atelier (opacité
// .85, min 320px) sur un fond encore plus sombre.
export default function ProContactBandSection({ props = {} }) {
  return (
    <section className="relative overflow-hidden" style={DARK_BG}>
      <div className={`${CONTAINER} grid [grid-template-columns:repeat(auto-fit,minmax(320px,1fr))]`}>
      <div className="relative px-5 md:px-11 py-[60px]">
        <RichText
          as="h2"
          className="block font-display font-light text-[clamp(24px,2.8vw,34px)] leading-[1.2] text-cream mb-[18px] [text-wrap:balance]"
          html={props.heading}
        />
        <RichText
          as="div"
          preserveParagraphs
          className="text-[14px] leading-[1.8] font-light text-cream/[0.7] mb-[30px] [text-wrap:pretty]"
          html={props.body}
        />
        <div className="grid gap-3.5 text-[14px] font-light text-cream/[0.85]">
          {props.phone && (
            <div className={ROW}>
              <span className={KEY}>Tél.</span>
              <a href={telHref(props.phone)} className="text-cream/[0.85] hover:text-cream" dir="ltr">{props.phone}</a>
            </div>
          )}
          {props.mobile && (
            <div className={ROW}>
              <span className={KEY}>Mobile</span>
              <a href={telHref(props.mobile)} className="text-cream/[0.85] hover:text-cream" dir="ltr">{props.mobile}</a>
            </div>
          )}
          {props.address && (
            <div className={ROW}>
              <span className={KEY}>Adresse</span>
              <span>{props.address}</span>
            </div>
          )}
        </div>
        {props.cta_label && (
          <a href={props.cta_url || telHref(props.phone)} className={`${BTN_INVERSE} mt-8`}>
            {props.cta_label}
          </a>
        )}
      </div>
      <div className="relative min-h-[320px] bg-black/40">
        <MutedVideo
          src={props.video_url}
          poster={props.poster_image}
          opacity={0.85}
          className="w-full h-full min-h-[320px] object-cover block"
        />
      </div>
      </div>
    </section>
  );
}
